import { legacyContractDataAttrs } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { getMsgDeskRuntime } from '@/msgdeskRuntime'
import { QuickReplyModal } from './QuickReplyModal'
import { useSharedSurface } from './SharedSurfaceContext'

// Quick-reply form (e927-e942), pin form (e943-e944), loading overlay (e945-e947).

export function ShellOverlays() {
  const isTestMode = getMsgDeskRuntime().isTestMode()
  return (
    <>
      {isTestMode ? <TestModeBadge /> : null}
      <DialogOverlayShell />
      <SavingOverlay />
      <MessageBoxOverlay />
    </>
  )
}

function TestModeBadge() {
  const { skin } = useSharedSurface()
  return (
    <div className={`md-test-mode-badge ${skin.testBadge}`}>
      TEST MODE (v2)
      <div id="test_mode_info" className={`md-test-mode-badge__info ${skin.testBadgeInfo}`}>info</div>
    </div>
  )
}

function DialogOverlayShell() {
  const { skin } = useSharedSurface()
  return (
    <>
      <div className={`md-dialog-shell__backdrop ${skin.dialogBackdrop}`} />
      <div className={`md-dialog-shell__window ${skin.dialogWindow}`}>
        <div className="md-dialog-shell__height" />
        <div className="md-dialog-shell__info" />
      </div>
    </>
  )
}

function SavingOverlay() {
  const { Loading, skin } = useSharedSurface()
  return (
    <>
      <div className={`md-saving-overlay__backdrop ${skin.savingBackdrop}`} />
      <div className={`md-saving-overlay__content ${skin.savingContent}`} data-md-legacy-id="mcss-trnsp-cssm">
        <Loading variant="overlay" label="Saving changes" className="md-saving-overlay__heading" />
      </div>
    </>
  )
}

function MessageBoxOverlay() {
  const { Loading, skin } = useSharedSurface()
  return (
    <div className={`md-message-box-overlay ${skin.msgBoxOverlay}`}>
      <div className={`md-message-box-overlay__spacer ${skin.msgBoxSpacer}`} />
      <div className={`md-shell-msg-box ${skin.msgBox}`} data-md-legacy-id="mcss-msg_box-cssm">
        <div className={`md-shell-msg-box__info ${skin.msgBoxInfo}`}>
          <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==" alt="" />
          <Loading variant="inline" label="Loading message" className={`md-shell-msg-box__text ${skin.msgBoxText}`} />
          <ul><li /></ul>
        </div>
        <div className={`md-shell-msg-box__pin ${skin.msgBoxPin}`}>
          <input data-md-legacy-id="mcss-msg_box_input-cssm" type="password" onClick={(event) => { event.currentTarget.value = '' }} defaultValue="" />
          <input data-md-legacy-id="mcss-msg_box_input_2-cssm" type="password" onClick={(event) => { event.currentTarget.value = '' }} defaultValue="" />
        </div>
        <div className="md-shell-msg-box__captcha">
          <img className={skin.msgBoxCaptchaImg} src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==" alt="" />
        </div>
        <div className={`md-shell-msg-box__buttons ${skin.msgBoxButtons}`}>
          <span className={`md-shell-msg-box__close ${skin.msgBoxClose}`}>Cancel</span>
          <span className={`md-shell-msg-box__hidden-cancel ${skin.msgBoxHiddenCancel}`}>Cancel</span>
        </div>
      </div>
    </div>
  )
}

export function QuickReply() {
  return <QuickReplyModal />
}

export function EnterPinForm() {
  return (
    // SKELETON: pin contracts are legacy password/pin targets.
    <div {...legacyContractDataAttrs('editor.pin.root')}>
      <input type="text" {...legacyContractDataAttrs('editor.pin.input')} defaultValue="" />
    </div>
  )
}

export function LoadingOverlay() {
  const { Loading } = useSharedSurface()
  return (
    // SKELETON: editor.loading is a legacy loading overlay target.
    <Loading variant="inline" contract="editor.loading" label="Loading" />
  )
}
